import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "m8.414 13.414 3.172 3.172c1.26 1.26 3.414.367 3.414-1.414V8.828c0-1.781-2.154-2.674-3.414-1.414l-3.172 3.172a2 2 0 0 0 0 2.828"
    }
  )
);
var SvgArrowLeftFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ArrowLeftFilled_default = SvgArrowLeftFilled;

export { ArrowLeftFilled_default as default };
